import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProducts } from "../../services/productApi";
import { getProductImages } from "../../services/imageApi";
import "./home.css";

const Home = () => {
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [imagesMap, setImagesMap] = useState({});
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    const data = await getProducts();
    setProducts(data);
    extractCategories(data);
    loadImages(data);
  };

  const extractCategories = (products) => {
    const set = new Set();
    products.forEach((p) => p.category_name && set.add(p.category_name));
    setCategories(Array.from(set));
  };

  const loadImages = async (products) => {
    const results = await Promise.all(
      products.map(async (p) => {
        try {
          const imgs = await getProductImages(p.id);
          return { id: p.id, imgs };
        } catch {
          return { id: p.id, imgs: [] };
        }
      })
    );

    const map = {};
    results.forEach((r) => (map[r.id] = r.imgs));
    setImagesMap(map);
  };

  const getImage = (p) => {
    const img = imagesMap[p.id]?.[0];
    return img
      ? `${img.image_url}`
      : "https://via.placeholder.com/300";
  };

  // Sections
  const trending = products.slice(0, 8);
  const featured = products.slice(8, 16);

  return (
    <div className="home">

      {/* 🔥 HERO */}
      <div className="hero">
        <h1>Big Deals. Big Savings.</h1>
        <p>Discover top products at best prices</p>
        <button onClick={() => navigate("/shop")}>
          Shop Now
        </button>
      </div>

      {/* 📦 CATEGORIES */}
      <div className="categories">
        <h2>Shop by Category</h2>
        <div className="category-list">
          {categories.map((c, i) => (
            <div
              key={i}
              className="category-card"
              onClick={() => navigate(`/shop?category=${c}`)}
            >
              {c}
            </div>
          ))}
        </div>
      </div>

      {/* 🔥 TRENDING SLIDER */}
      <div className="section">
        <h2>🔥 Trending Products</h2>

        <div className="slider">
          {trending.map((p) => (
            <div
              key={p.id}
              className="slider-card"
              onClick={() => navigate(`/product/${p.id}`)}
            >
              <img src={getImage(p)} alt={p.name} />
              <p>{p.name}</p>
              <span>₹{p.price}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ⭐ FEATURED GRID */}
      <div className="section">
        <h2>⭐ Featured Products</h2>

        <div className="grid">
          {featured.map((p) => (
            <div
              key={p.id}
              className="card"
              onClick={() => navigate(`/product/${p.id}`)}
            >
              <img src={getImage(p)} alt={p.name} />
              <h3>{p.name}</h3>
              <p>₹{p.price}</p>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default Home;